import React from "react";
import { params, shape, string as stringType, useDataModel } from "@thd-nucleus/data-sources";
import { Image } from "@thd-olt-component-react/image";
import { VideoPlayer } from "@thd-olt-component-react/video-player";
import { string } from "prop-types";

export const ArticleInfoHero = ({ articleGUID }) => {
  const { data, loading, error } = useDataModel("article", { variables: { articleGUID } });

  if (error || loading || !data) return null;

  const {
    heroAlt = "",
    heroName = "",
    source = "",
    type,
    preview = "",
    thumbnail,
  } = data?.article?.articleHeader || {};

  const articleType = data?.article?.articleType || "ap";
  const articleTypeMappings = {
    ab: "Buying Guide",
    ai: "Inspiration Guide",
    ah: "Project Guide",
    ap: "Influencer Guide",
  };

  const isVideo = type === "video";
  const videoSrc = preview.replace("watch?v=", "embed/");

  return isVideo ? (
    <VideoPlayer
      videoSrc={videoSrc}
      videoStill={thumbnail}
      analyticsData={{
        experienceName: "article",
        articleType: articleTypeMappings[articleType].toLowerCase(),
      }}
    />
  ) : (
    <Image src={source} alt={heroAlt} title={heroName} height={425} width={425} />
  );
};

ArticleInfoHero.propTypes = {
  articleGUID: string.isRequired,
};

ArticleInfoHero.displayName = "ArticleInfoHero";

ArticleInfoHero.dataModel = {
  article: params({ articleGUID: stringType().isRequired() }).shape({
    articleType: stringType(),
    articleHeader: shape({
      heroAlt: stringType(),
      heroName: stringType(),
      preview: stringType(),
      source: stringType(),
      thumbnail: stringType(),
      type: stringType(),
    }),
  }),
};
